import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import Cookies from "js-cookie";
import presensiProyekService from "../../services/presensiProyekService";
import tunjanganLainService from "../../services/tunjanganLainService";

export const initialState = {
    loading_presensi_proyek: false,
    data_presensi_proyek: [],
    data_import: [],
    showMessage:false,
    message:'',
}


export const getDataPresensiProyek = createAsyncThunk('presensi_proyek/data',async (data, { rejectWithValue }) => {
    try {
        const response = await presensiProyekService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getaDataImport = createAsyncThunk('presensi_proyek/dataimport',async (data, { rejectWithValue }) => {
    try {
        const response = await presensiProyekService.data_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const emptyDataImport = createAsyncThunk('presensi_proyek/emptyimport',async (data, { rejectWithValue }) => {
    try {
        const response = await presensiProyekService.empty_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const saveDataImport = createAsyncThunk('presensi_proyek/saveimport',async (data, { rejectWithValue }) => {
    try {
        const response = await presensiProyekService.save_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})


export const presensiProyekSlice = createSlice({
    name: 'presensi_proyek',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_presensi_proyek = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataPresensiProyek.fulfilled, (state, action) => {
                state.loading_presensi_proyek = false
                state.data_presensi_proyek = action.payload??[]
            })
            .addCase(getDataPresensiProyek.pending, (state) => {
                state.loading_presensi_proyek = true
            })
            .addCase(getDataPresensiProyek.rejected, (state, action) => {
                state.loading_presensi_proyek = false
                state.data_presensi_proyek = action.payload
            })
            .addCase(getaDataImport.fulfilled, (state, action) => {
                state.loading_presensi_proyek = false
                state.data_import = action.payload??[]
            })
            .addCase(getaDataImport.pending, (state) => {
                state.loading_presensi_proyek = true
            })
            .addCase(getaDataImport.rejected, (state, action) => {
                state.loading_presensi_proyek = false
                state.data_import = action.payload
            })

    },
})

export const {
    showLoading,
} = presensiProyekSlice.actions

export default presensiProyekSlice.reducer
